import { hasTeamAccess } from "../permissions";

export const hasLunchAccess = (user) => hasTeamAccess(user, "lunch");
